// extracted by mini-css-extract-plugin
export var button = "_1h-0";
export var buttonContent = "_1h-e";
export var buttonGroup = "_1h-c";
export var dontRestrainIconWidth = "_1h-a";
export var dropdownButton = "_1h-b";
export var iconContainer = "_1h-9";
export var lg = "_1h-4";
export var md = "_1h-3";
export var pending = "_1h-f";
export var sm = "_1h-2";
export var spinner = "_1h-d";
export var squared = "_1h-8";
export var wrapText = "_1h-g";
export var xl = "_1h-5";
export var xs = "_1h-1";
export var xxl = "_1h-6";
export var xxxl = "_1h-7";